import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {Switch, Space} from "antd";

import {
    getAllZones,
    clear_zones,
    createZone,
    CREATE_ZONE,
    updateZone,
    UPDATE_ZONE
} from "../../../redux/zones";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";

const Zones = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_zones = useSelector((state) => state.zones_module._get_all_zones);
    const _create_zone = useSelector((state) => state.zones_module._create_zone);
    const _update_zone = useSelector((state) => state.zones_module._update_zone);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (_get_all_zones.data.datos) {
            setData(_get_all_zones.data.datos);
        }
    }, [_get_all_zones]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        nombre: "",
        jefe_zona: "",
        correo_jefe_zona: "",
        correo_1: "",
        correo_2: "",
        activo: true,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_zones').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({
                            ...form, 
                            nombre: item.nombre, 
                            jefe_zona: item.jefe_zona !== null ? item.jefe_zona : '',
                            correo_jefe_zona: item.correo_jefe_zona !== null ? item.correo_jefe_zona : '',
                            correo_1: item.correo_backup1 !== null ? item.correo_backup1 : '',
                            correo_2: item.correo_backup2 !== null ? item.correo_backup2 : '',
                            activo: item.activo
                        });
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    useEffect(() => {
        if (_create_zone.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_zones(CREATE_ZONE));
            dispatch(getAllZones(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_zone.status !== 0) {
            dispatch(clear_zones(CREATE_ZONE));
            toast.error(_create_zone.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_zone, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_zone.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_zones(UPDATE_ZONE));
            dispatch(getAllZones(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_zone.status !== 0) {
            dispatch(clear_zones(UPDATE_ZONE));
            toast.error(_update_zone.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_zone, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.jefe_zona === "") {
            toast.error("Debe ingresar el jefe de zona", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.correo_jefe_zona === "") {
            toast.error("Debe ingresar el correo del jefe de zona", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createZone(token, form));
        } else {
            dispatch(updateZone(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Zonas", link: "/zonas"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_zones').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({
                                                ...form, 
                                                nombre: '', 
                                                jefe_zona: '', 
                                                correo_jefe_zona: '', 
                                                correo_1: '', 
                                                correo_2: '', 
                                                activo: true
                                            });
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "jefe_zona",
                                                label: "Jefe de zona",
                                                type: "text",
                                            },
                                            {
                                                name: "correo_jefe_zona",
                                                label: "Correo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id === 0 ? 'Crear ' : 'Editar '} zonas</h5>
                        <div className="form-group">
                            <Input
                                label="Nombre"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Jefe de zona"
                                name="jefe_zona"
                                value={form.jefe_zona}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Correo del jefe de zona"
                                name="correo_jefe_zona"
                                value={form.correo_jefe_zona}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Correo 1"
                                name="correo_1"
                                value={form.correo_1}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Correo 2"
                                name="correo_2"
                                value={form.correo_2}
                                onChange={handleChange}
                            />
                        </div>
                        {id !== 0 &&
                            <div className="form-group">
                                <Space size={14} direction='horizontal'>
                                    <strong>Activo</strong>
                                    <Switch
                                        checked={form.activo}
                                        checkedChildren="SI"
                                        unCheckedChildren="NO"
                                        onChange={handleCheckedChange}
                                    />
                                </Space>
                            </div>
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default Zones;
